// @ts-nocheck
import type { Question } from '../types';

export const prohibitorySignsQuestions: Question[] = [
  {
    id: "q-ps-1",
    question: "Identify the road sign:",
    answerId: "q-ps-1o2",
    topic: "General",
    options: [
      {
        id: "q-ps-1o1",
        text: "Maximum speed 50 km/h"
      },
      {
        id: "q-ps-1o2",
        text: "Speed limit ends"
      },
      {
        id: "q-ps-1o3",
        text: "Minimum speed 50 km/h"
      }
    ],
    explanation: "This sign indicates the end of a previously imposed 50 km/h speed limit. National or other posted speed limits now apply.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-1.png",
    imageHint: "speed limit ends"
  },
  {
    id: "q-ps-2",
    question: "Identify the road sign:",
    answerId: "q-ps-2o1",
    topic: "General",
    options: [
      {
        id: "q-ps-2o1",
        text: "Vehicles weighing heavier than indicated forbidden"
      },
      {
        id: "q-ps-2o2",
        text: "No entry for lorries"
      },
      {
        id: "q-ps-2o3",
        text: "Axle weight limit 5,4t"
      }
    ],
    explanation: "This sign prohibits vehicles with an actual weight exceeding 5,4 tonnes from proceeding.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-2.png",
    imageHint: "weight limit 5.4t"
  },
  {
    id: "q-ps-3",
    question: "Identify the road sign:",
    answerId: "q-ps-3o3",
    topic: "General",
    options: [
      {
        id: "q-ps-3o1",
        text: "Agricultural vehicles route"
      },
      {
        id: "q-ps-3o2",
        text: "No entry for slow vehicles"
      },
      {
        id: "q-ps-3o3",
        text: "Tractors prohibited"
      }
    ],
    explanation: "This sign indicates that tractors and other specified agricultural vehicles are prohibited from this road.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-3.png",
    imageHint: "no tractors"
  },
  {
    id: "q-ps-4",
    question: "Identify the road sign:",
    answerId: "q-ps-4o1",
    topic: "General",
    options: [
      {
        id: "q-ps-4o1",
        text: "Cyclists not permitted"
      },
      {
        id: "q-ps-4o2",
        text: "Cycle route ahead"
      },
      {
        id: "q-ps-4o3",
        text: "Shared path for pedestrians and cyclists"
      }
    ],
    explanation: "This sign means no entry for bicycles. Cyclists must find an alternative route.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-4.png",
    imageHint: "no cyclists"
  },
  {
    id: "q-ps-5",
    question: "Identify the road sign:",
    answerId: "q-ps-5o2",
    topic: "General",
    options: [
      {
        id: "q-ps-5o1",
        text: "No parking zone"
      },
      {
        id: "q-ps-5o2",
        text: "Stopping and parking forbidden"
      },
      {
        id: "q-ps-5o3",
        text: "Clearway, no stopping on carriageway"
      }
    ],
    explanation: "This sign indicates that stopping and parking are forbidden along this section of road.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-5.png",
    imageHint: "no stopping parking"
  },
  {
    id: "q-ps-6",
    question: "Identify the road sign:",
    answerId: "q-ps-6o3",
    topic: "General",
    options: [
      {
        id: "q-ps-6o1",
        text: "Speed limit 30 km/h applies"
      },
      {
        id: "q-ps-6o2",
        text: "End of all restrictions in zone"
      },
      {
        id: "q-ps-6o3",
        text: "End of the zone with speed limit"
      }
    ],
    explanation: "This sign marks the end of a zone where a specific speed limit (e.g., 30 km/h) was in force.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-6.png",
    imageHint: "end speed zone"
  },
  {
    id: "q-ps-7",
    question: "Identify the road sign:",
    answerId: "q-ps-7o1",
    topic: "General",
    options: [
      {
        id: "q-ps-7o1",
        text: "Begin of a zone with speed limit"
      },
      {
        id: "q-ps-7o2",
        text: "Residential area, walking speed"
      },
      {
        id: "q-ps-7o3",
        text: "Recommended speed 30 km/h"
      }
    ],
    explanation: "This sign indicates the beginning of a zone where a specific speed limit (in this case, 30 km/h) applies.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-7.png",
    imageHint: "begin speed zone 30"
  },
  {
    id: "q-ps-8",
    question: "Identify the road sign:",
    answerId: "q-ps-8o2",
    topic: "General",
    options: [
      {
        id: "q-ps-8o1",
        text: "Overtaking permitted"
      },
      {
        id: "q-ps-8o2",
        text: "End of the overtaking prohibition"
      },
      {
        id: "q-ps-8o3",
        text: "No overtaking by lorries"
      }
    ],
    explanation: "This sign indicates the end of a previously imposed overtaking prohibition. Standard overtaking rules now apply.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-8.png",
    imageHint: "end no overtaking"
  },
  {
    id: "q-ps-9",
    question: "Identify the road sign:",
    answerId: "q-ps-9o2",
    topic: "General",
    options: [
      {
        id: "q-ps-9o1",
        text: "No entry for any vehicles"
      },
      {
        id: "q-ps-9o2",
        text: "Cyclists, mopeds and tractors prohibited"
      },
      {
        id: "q-ps-9o3",
        text: "Route for agricultural vehicles and cycles only"
      }
    ],
    explanation: "This sign prohibits entry for cyclists, mopeds, and tractors.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-9.png",
    imageHint: "no cyclists mopeds tractors"
  },
  {
    id: "q-ps-10",
    question: "Identify the road sign:",
    answerId: "q-ps-10o2",
    topic: "General",
    options: [
      {
        id: "q-ps-10o1",
        text: "Motorcycles must use this lane"
      },
      {
        id: "q-ps-10o2",
        text: "Motorbikes - Motorcycles prohibited"
      },
      {
        id: "q-ps-10o3",
        text: "Motorcycle parking area"
      }
    ],
    explanation: "This sign indicates that motorcycles (motorbikes) are prohibited from using this road or area.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-10.png",
    imageHint: "no motorcycles"
  },
  {
    id: "q-ps-11",
    question: "Identify the road sign:",
    answerId: "q-ps-11o1",
    topic: "General",
    options: [
      {
        id: "q-ps-11o1",
        text: "No parking"
      },
      {
        id: "q-ps-11o2",
        text: "No entry for motor vehicles"
      },
      {
        id: "q-ps-11o3",
        text: "No entry for cars"
      }
    ],
    explanation: "This red circular sign with blue inner circle and diagonal line indicates that parking is prohibited in this area.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-1.png",
    imageHint: "no parking"
  },
  {
    id: "q-ps-12",
    question: "Identify the road sign:",
    answerId: "q-ps-12o1",
    topic: "General",
    options: [
      {
        id: "q-ps-12o1",
        text: "Entry not allowed / forbidden (checkpoint)"
      },
      {
        id: "q-ps-12o2",
        text: "No entry for motor vehicles"
      },
      {
        id: "q-ps-12o3",
        text: "No entry for cars"
      }
    ],
    explanation: "This red circular sign with horizontal bar indicates that entry is not allowed or forbidden, often used at checkpoints or restricted areas.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-2.png",
    imageHint: "entry not allowed forbidden checkpoint"
  },
  {
    id: "q-ps-13",
    question: "Identify the road sign:",
    answerId: "q-ps-13o1",
    topic: "General",
    options: [
      {
        id: "q-ps-13o1",
        text: "Overtaking not allowed"
      },
      {
        id: "q-ps-13o2",
        text: "No entry for motor vehicles"
      },
      {
        id: "q-ps-13o3",
        text: "No entry for cars"
      }
    ],
    explanation: "This red circular sign with two vehicles facing each other indicates that overtaking is not allowed on this road.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-3.png",
    imageHint: "overtaking not allowed"
  },
  {
    id: "q-ps-14",
    question: "Identify the road sign:",
    answerId: "q-ps-14o1",
    topic: "General",
    options: [
      {
        id: "q-ps-14o1",
        text: "Height restriction ahead"
      },
      {
        id: "q-ps-14o2",
        text: "Height limit 3.1m"
      },
      {
        id: "q-ps-14o3",
        text: "Low bridge ahead"
      }
    ],
    explanation: "This sign indicates a height restriction ahead. Vehicles exceeding the specified height are prohibited from using this road or area.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-4.png",
    imageHint: "height restriction ahead"
  },
  {
    id: "q-ps-15",
    question: "Identify the road sign:",
    answerId: "q-ps-15o1",
    topic: "General",
    options: [
      {
        id: "q-ps-15o1",
        text: "No turning / u-turn allowed"
      },
      {
        id: "q-ps-15o2",
        text: "U-turn permitted"
      },
      {
        id: "q-ps-15o3",
        text: "Turn around ahead"
      }
    ],
    explanation: "This red circular sign with a white U-turn arrow indicates that turning and U-turns are not allowed at this location.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-5.png",
    imageHint: "no turning u-turn allowed"
  },
  {
    id: "q-ps-16",
    question: "Identify the road sign:",
    answerId: "q-ps-16o1",
    topic: "General",
    options: [
      {
        id: "q-ps-16o1",
        text: "Vehicles - Cars prohibited"
      },
      {
        id: "q-ps-16o2",
        text: "No entry for cars"
      },
      {
        id: "q-ps-16o3",
        text: "Motor vehicle route"
      }
    ],
    explanation: "This red circular sign with a car silhouette indicates that vehicles, specifically cars, are prohibited from using this road or area.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-6.png",
    imageHint: "vehicles cars prohibited"
  },
  {
    id: "q-ps-17",
    question: "Identify the road sign:",
    answerId: "q-ps-17o1",
    topic: "General",
    options: [
      {
        id: "q-ps-17o1",
        text: "Speed limit"
      },
      {
        id: "q-ps-17o2",
        text: "Maximum speed 50 km/h"
      },
      {
        id: "q-ps-17o3",
        text: "Speed limit ends"
      }
    ],
    explanation: "This red circular sign with a number indicates a speed limit that must not be exceeded on this road.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-7.png",
    imageHint: "speed limit"
  },
  {
    id: "q-ps-18",
    question: "Identify the road sign:",
    answerId: "q-ps-18o1",
    topic: "General",
    options: [
      {
        id: "q-ps-18o1",
        text: "Vehicles with dangerous goods prohibited"
      },
      {
        id: "q-ps-18o2",
        text: "Lorry route"
      },
      {
        id: "q-ps-18o3",
        text: "Lorry parking area"
      }
    ],
    explanation: "This red circular sign with a symbol for dangerous goods indicates that vehicles carrying dangerous goods are prohibited from using this road or area.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-8.png",
    imageHint: "vehicles dangerous goods prohibited"
  },
  {
    id: "q-ps-19",
    question: "Identify the road sign:",
    answerId: "q-ps-19o1",
    topic: "General",
    options: [
      {
        id: "q-ps-19o1",
        text: "End of the overtaking prohibition for trucks"
      },
      {
        id: "q-ps-19o2",
        text: "Motor vehicle route"
      },
      {
        id: "q-ps-19o3",
        text: "Motor vehicle parking area"
      }
    ],
    explanation: "This sign indicates the end of the overtaking prohibition for trucks. After this sign, trucks are no longer prohibited from overtaking.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-9.png",
    imageHint: "end overtaking prohibition trucks"
  },
  {
    id: "q-ps-20",
    question: "Identify the road sign:",
    answerId: "q-ps-20o1",
    topic: "General",
    options: [
      {
        id: "q-ps-20o1",
        text: "Mopeds prohibited"
      },
      {
        id: "q-ps-20o2",
        text: "Moped route"
      },
      {
        id: "q-ps-20o3",
        text: "Moped parking area"
      }
    ],
    explanation: "This sign indicates that mopeds are prohibited from using this road or area.",
    subject: "Prohibitory Signs",
    questionType: 'hotspot',
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-10.png",
    imageHint: "mopeds prohibited"
  },
  {
    id: "q-ps-21",
    question: "What does the 'No Parking' sign indicate?",
    answerId: "q-ps-21o2",
    topic: "General",
    options: [
      {
        id: "q-ps-21o1",
        text: "Parking is allowed but only for 1 hour"
      },
      {
        id: "q-ps-21o2",
        text: "Parking is absolutely prohibited in this area"
      },
      {
        id: "q-ps-21o3",
        text: "Parking is allowed but only for residents"
      }
    ],
    explanation: "The 'No Parking' sign (red circle with white X) prohibits parking absolutely in the marked area. Vehicles found parked here will be subject to fines and possible removal. (RVV 1990 art. 12)",
    subject: "Prohibitory Signs",
    imageUrl: "https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-ps-21.jpg"
  }
];
